import styled from 'styled-components';

export const MainWrapper = styled.div`
  display: flex;
`;

export const SidebarWrapper = styled.div`
  flex: 0 0 74px;
`;

export const ContentWrapper = styled.div`
  flex-grow: 1;
`;

export const PageWrapper = styled.div`
  background: ${({ theme }) => theme.colors.grey001};
`;
